<template>
  <div id="ControlBatchReport" class="q-pa-md">
    <div class="crud-title"><translate>PRE_MEANSUREMENT_REPORT</translate></div>
    <crud-layout
      v-if="!reportForms"
      ref="crudLayout"
      :name="name"
      :interface="nmInterface"
      :id="id"
    >
    </crud-layout>
    <control-batch-report-measurement-report v-else @on-close="onCloseReport" :format="format" :forms="reportForms" />
  </div>
</template>
<script>
import { Component, Vue } from 'vue-property-decorator'
import { JtCrud } from 'jtech-webcomps'
import { repository } from 'jtech'
import ControlBatchReportMeasurementReport from './ControlBatchReportMeasurementReport'

const { CrudLayout } = JtCrud

@Component({
  name: 'ControlBatchReport',
  components: {
    CrudLayout,
    ControlBatchReportMeasurementReport
  },
  props: {
    id: String,
    interface: String,
    name: String
  }
})
class ControlBatchReport extends Vue {
  reportForms = null;
  format = null;

  mounted () {
    this.$refs.crudLayout.onButton('btGerarPdf', this.reportButtonPdf)
    this.$refs.crudLayout.onButton('btGerarXls', this.reportButtonXls)
  }

  updated () {
    try {
      this.$refs.crudLayout.onButton('btGerarPdf', this.reportButtonPdf)
      this.$refs.crudLayout.onButton('btGerarXls', this.reportButtonXls)
    } catch (error) {
    }
  }

  async reportButtonPdf ({ button, params }) {
    this.format = 'pdf'
    const extraParams = { id: params.id, client: params.client, collectionPoint: params.collectionPoint, relFormatoRelatorio: 1 }
    const repoForm = await repository.resolve('billingOrderMeasurementReport.billingOrderMeasurementReport', extraParams)
    repoForm[0].dadosForm = { ...repoForm[0].dadosForm, ...extraParams }
    this.reportForms = repoForm
  }

  async reportButtonXls ({ button, params }) {
    this.format = 'xls'
    const extraParams = { id: params.id, client: params.client, collectionPoint: params.collectionPoint, relFormatoRelatorio: 3 }
    const repoForm = await repository.resolve('billingOrderMeasurementReport.billingOrderMeasurementReport', extraParams)
    repoForm[0].dadosForm = { ...repoForm[0].dadosForm, ...extraParams }
    this.reportForms = repoForm
  }

  onCloseReport () {
    this.reportForms = null
  }

  get nmInterface () {
    return this.interface
  }
}

export default ControlBatchReport
</script>

<style lang="stylus" scoped></style>
